import { render, staticRenderFns } from "./BhSelect.vue?vue&type=template&id=a9d599aa&scoped=true&"
import script from "./BhSelect.vue?vue&type=script&lang=js&"
export * from "./BhSelect.vue?vue&type=script&lang=js&"
import style0 from "./BhSelect.vue?vue&type=style&index=0&id=a9d599aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d599aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
